import api from "../../../api/axios";

// Bounded Client / Property candidate search for calendar Task editor.
// Reuses existing authenticated list endpoints; does not weaken visibility.

const DEFAULT_PAGE_SIZE = 20;

export const searchClientCandidates = (params = {}, { signal } = {}) => {
  const { search, page = 1, page_size = DEFAULT_PAGE_SIZE } = params;
  const query = {
    page,
    page_size,
    ordering: "-created_at",
  };
  if (search && String(search).trim()) {
    query.search = String(search).trim();
  }
  return api.get("/crm/clients/", { params: query, signal }).then((res) => res.data);
};

export const searchPropertyCandidates = (params = {}, { signal } = {}) => {
  const { search, page = 1, page_size = DEFAULT_PAGE_SIZE } = params;
  const query = {
    page,
    page_size,
    ordering: "-created_at",
  };
  if (search && String(search).trim()) {
    query.search = String(search).trim();
  }
  return api
    .get("/realty/properties/", { params: query, signal })
    .then((res) => res.data);
};

export const unwrapPagedResults = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};
